import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogClose } from '@qualifio/ui-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { useTranslation } from 'react-i18next';
import { useTestUsers } from './TestUsersContext';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  profile?: ProfileAttributes;
  onDeleted: () => void;
}

export function DeleteTestUserDialog({ isOpen, setIsOpen, profile, onDeleted }: Props) {
  const { t } = useTranslation();
  const { deleteTestUser, isLoading } = useTestUsers();

  const onClose = () => setIsOpen(false);
  const loading = isLoading(deleteTestUser);
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth color="warning">
      <DialogClose close={onClose} />
      <DialogTitle>{t('test-users.actions.delete.title', { email: profile?.email })}</DialogTitle>
      <DialogContent sx={{ textAlign: 'start !important' }}>
        <p>{t('test-users.actions.delete.description')}</p>
      </DialogContent>
      <DialogActions>
        <Button color="grey" onClick={onClose} disabled={loading}>
          {t('generic.actions.cancel')}
        </Button>
        <Button
          color="error"
          startIcon={loading && <FontAwesomeIcon icon={faSpinner} spin />}
          disabled={loading}
          onClick={() => {
            if (profile) {
              deleteTestUser(profile).then(() => {
                onClose();
                onDeleted();
              });
            } else {
              onClose();
              onDeleted();
            }
          }}
        >
          {t('generic.actions.hard-delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
